import { Subscription, Tunnel, TunnelWindow } from "./index";

/**
 * @hidden
 */
function disposableFromFunction(f: () => void): Subscription {
    return {
        dispose: () => {
            f();
        }
    };
}

/**
 * @hidden
 */
export class DefaultTunnel implements Tunnel {
    constructor(private $window: TunnelWindow) {
        this.setWindow($window);
    }
    setWindow($window: TunnelWindow) {
        if ($window) {
            this.$window = $window;
        }
        else {
            throw new Error("window must be defined.");
        }
    }
    subscribe<T>(handler: (event: MessageEvent<T>) => void): Subscription {
        this.$window.addEventListener('message', handler);
        return disposableFromFunction(() => {
            this.$window.removeEventListener('message', handler);
        });
    }
    postMessage<T>(message: T, transfer?: Transferable[]): void {
        try {
            const targetOrigin = typeof document !== 'undefined' ? document.location.origin : "";
            // console.lg(`targetOrigin=>${targetOrigin}`);
            this.$window.parent.postMessage(message, targetOrigin, transfer);
        } catch (e) {
            console.error(`${JSON.stringify(message)}`);
            console.error(`Cause: ${e}`);
        }
    }
}
